export function shortNumber(num, fixed) {
    return  new Intl.NumberFormat('en-US', {maximumFractionDigits: 6, notation: 'standard', compactDisplay: 'long'}).format(num)
}